import { ImageOff } from "lucide-react";
import { useParams } from "react-router-dom";
import { usePhotos } from "../../../hooks/use-files";
import { ErrorState, LoadingSpinner } from "../../ui/loading";
import { Section } from "./section";

export function SectionPhotos(): React.ReactElement {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isError, error } = usePhotos(id);

  const photos = [...(data?.photos ?? [])].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <Section id="photos" title="Photos">
      {isLoading && (
        <div className="flex justify-center py-6">
          <LoadingSpinner />
        </div>
      )}
      {isError && <ErrorState message={error instanceof Error ? error.message : "Failed to load photos"} />}
      {!isLoading && !isError && photos.length === 0 && (
        <div className="flex flex-col items-center gap-2 py-6 text-sm text-muted-foreground">
          <ImageOff className="h-6 w-6" />
          No photos.
        </div>
      )}
      {!isLoading && !isError && photos.length > 0 && (
        <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
          {photos.map((photo) => (
            <div key={photo.id} className="rounded-md border overflow-hidden">
              <div className="aspect-square bg-muted">
                <img src={photo.url} alt={photo.caption ?? "Photo"} className="h-full w-full object-cover" />
              </div>
              {photo.caption && <p className="p-2 text-xs text-muted-foreground truncate">{photo.caption}</p>}
            </div>
          ))}
        </div>
      )}
    </Section>
  );
}
